import React from "react";
import Meta from "./../components/Meta";
import HeroSection4 from "./../components/HeroSection4";
import FeaturesSection4 from "./../components/FeaturesSection4";
import PricingSection2 from "./../components/PricingSection2";
import NewsletterSection from "./../components/NewsletterSection";
import FeaturesSection5 from "./../components/FeaturesSection5";
import Section from "../components/Section";

function AccountableAiPage(props) {
  return (
    <>
      <br>
      </br>
      <br>
      </br>
      <Meta title="Accountable AI" />
      <HeroSection4
        color="white"
        size="medium"
        backgroundImage="/halftone-1696542371.svg"
        backgroundImageOpacity={1}
        title="Accountable AI"
        subtitle="Use PDS as a clearance system for data scraping by LLMs and prompt output usage by GPT applications. Our system and licensing protocol include native compatibility with AI/LLM systems, and our Accountable AI web app provides a blueprint for the development of legally sound, end-to-end AI licensing tools that fairly compensate IP rights holders for usage of their data."
        image="pds-portfolio-loading-animation.gif"
        buttonText="Get Started"
        buttonColor="primary"
        buttonInverted={false}
        buttonPath="/contact"
      />
      <Section
        color="secondary"
        size="normal"
        title="PDS Digital Property Rights Protocol for AI" 
        subtitle="Use our decentralized and secure system to protect your data/IP from unauthorized use by LLMs and GPT-enabled applications."
        backgroundImage=""
        backgroundImageOpacity=""
        className="has-text-centered"
      />
      <FeaturesSection4
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        image="ai_graphic2.svg"
      />
      <Section
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title="Protect (and monetize) your property rights" 
        subtitle="Work with us to build a more accountable, sustainable and legally sound AI ecosystem that respects human creativity and intellectual property rights."
        className="has-text-centered"
      />
      <FeaturesSection5
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
      />
      <Section
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title="" 
        subtitle=""
        className="has-text-centered"
      />
      <PricingSection2
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        title="AI Products"
        subtitle="PDS developers have built a number of apps and app services to demonstrate and support PDS’ AI-facing data management capabilities."
      />
      <NewsletterSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Join us!"
        subtitle="Sign up to receive updates about PDS AI initiatives and application releases."
        buttonText="Subscribe"
        buttonColor="primary"
        buttonInverted={false}
        inputPlaceholder="Enter your email"
        subscribedMessage="You are now subscribed!"
      />

    </>
  );
}

export default AccountableAiPage;
